module.exports = __webpack_public_path__ + "assets/images/bpm-background.ee4a55539eeb9762ca6b7b037664b192.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bpm-background.png
// module id = 8
// module chunks = 0